import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Home, Globe } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LANGUAGES = [
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
];

const FeatureDetailPage = ({ featureKey, defaultTitle }) => {
  const navigate = useNavigate();
  const [language, setLanguage] = useState('en');
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadContent();
  }, [language, featureKey]);

  const loadContent = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API}/content/${featureKey}/${language}`);
      setContent(response.data.content || 'Content not available yet. Please check back later.');
    } catch (error) {
      console.error('Error loading content:', error);
      setContent('Content not available yet. Please check back later.');
    } finally {
      setLoading(false);
    }
  };

  const trackView = async () => {
    try {
      await axios.post(`${API}/analytics/track`, {
        event_type: 'page_view',
        page: featureKey,
        language: language,
      });
    } catch (error) {
      console.error('Error tracking view:', error);
    }
  };

  useEffect(() => {
    trackView();
  }, [language]);

  return (
    <div className="feature-detail-page">
      <div className="feature-detail-container">
        {/* Header with Language Switcher and Home Button */}
        <div className="feature-detail-header">
          <Button
            variant="outline"
            onClick={() => navigate('/')}
            className="home-button"
          >
            <Home className="mr-2 h-4 w-4" />
            Home
          </Button>

          <div className="language-switcher">
            <Globe className="mr-2 h-4 w-4" />
            {LANGUAGES.map((lang) => (
              <button
                key={lang.code}
                onClick={() => setLanguage(lang.code)}
                className={`language-btn ${language === lang.code ? 'active' : ''}`}
                title={lang.label}
              >
                {lang.flag}
              </button>
            ))}
          </div>
        </div>

        {/* Content Card */}
        <Card className="feature-detail-card">
          <CardContent className="feature-detail-content">
            {loading ? (
              <div className="loading-state">Loading content...</div>
            ) : (
              <div className="content-text" dangerouslySetInnerHTML={{ __html: content }} />
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default FeatureDetailPage;
